import { ReactComponent as PaginationFirst } from "assets/common/common/pagination_first_bk.svg";
import { ReactComponent as PaginationPrev } from "assets/common/common/pagination_prev_bk.svg";
import { ReactComponent as PaginationNext } from "assets/common/common/pagination_next_bk.svg";
import { ReactComponent as PaginationLast } from "assets/common/common/pagination_last_bk.svg";
import { twMerge } from "tailwind-merge";

type PaginationProps = {
    total: number;
    current: number;
    groupSize?: number;
    pageSize?: number;
    onChange: (page: number) => void;
    className?: string;
};

export default function Pagination({ total, current, groupSize = 10, pageSize = 10, onChange, className }: PaginationProps) {
    const pageCount = Math.ceil(total / pageSize);
    const safeCurrent = Math.max(current, 1);
    const currentGroup = Math.floor((safeCurrent - 1) / groupSize);

    const startPage = currentGroup * groupSize + 1;
    const endPage = Math.min(startPage + groupSize - 1, pageCount);

    const pages = Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i);

    // 점프 버튼에 들어갈 로직
    // const prevJumpPage = Math.max((currentGroup - 1) * groupSize + 1, 1);
    // const nextJumpPage = Math.min((currentGroup + 1) * groupSize + 1, pageCount);
    const prevJumpPage = Math.max(startPage - groupSize, 1);
    const nextJumpPage = Math.min(startPage + groupSize, pageCount);

    const style = twMerge("flex items-center gap-[20px] justify-center w-full", className);

    return (
        <div className={style}>
            <div className="flex items-center">
                {/* << 10개 이전 */}
                <button onClick={() => onChange(prevJumpPage)} className="px-2 py-1" disabled={current === 1}>
                    <PaginationFirst />
                </button>

                {/* < 이전 */}
                <button onClick={() => onChange(Math.max(current - 1, 1))} className="px-2 py-1" disabled={current === 1}>
                    <PaginationPrev />
                </button>
            </div>
            <div className="flex items-center space-x-1 flex-wrap">
                {/* 페이지 번호 */}
                {pages.map(page => (
                    <button
                        key={page}
                        onClick={() => onChange(page)}
                        className={`w-[30px] h-[30px] rounded ${page === current ? "bg-[#1B1C1E] text-white" : "hover:bg-gray-100"}`}
                    >
                        {page}
                    </button>
                ))}
            </div>
            <div className="flex items-center">
                {/* > 다음 */}
                <button onClick={() => onChange(Math.min(current + 1, total))} className="px-2 py-1" disabled={current === pageCount}>
                    <PaginationNext />
                </button>

                {/* >> 10개 이후 */}
                <button onClick={() => onChange(nextJumpPage)} className="px-2 py-1" disabled={startPage + groupSize > total}>
                    <PaginationLast />
                </button>
            </div>
        </div>
    );
}
